module.exports = __webpack_public_path__ + "img/dashboard-active.e8f221c6.svg";